import clsx from 'clsx'
import Image from 'next/legacy/image'

import Text from '~/components/Text/Text'
import Link from '~/components/Link/Link'
import { GITHUB_CLI_REPO_URL } from '~/constants'

import styles from './AboutHero.module.sass'

const shapeAltText = 'APIs testing made human'

const AboutHero: React.FC = () => {
  return (
    <div className={clsx('site-grid site-container', styles.section)}>
      <div className='flex justify-center col-span-2 md:hidden'>
        <Image
          src='/Images/about-shape-mobile.svg'
          layout='fixed'
          width={290}
          height={198}
          alt={shapeAltText}
          className={styles.shape}
          priority
        />
      </div>

      <div className='hidden md:flex md:justify-center md:col-start-2 md:col-end-8 lg:col-start-4 lg:col-end-10'>
        <Image
          src='/Images/about-shape.svg'
          layout='fixed'
          width={297}
          height={258}
          alt={shapeAltText}
          className={styles.shape}
          priority
        />
      </div>

      <div
        className={clsx('col-span-full md:col-start-2 md:col-end-8 lg:col-start-4 lg:col-end-10', styles.textSection)}
      >
        <Text variant='subheading' fontSize={[28, 28, 40]}>
          APIs <s>are hard</s> made human
        </Text>
        {/*
        <Text fontSize={[18, 14, 18]} className={styles.description}>
          It all started with a problem.
          API testing was slowing us down in building a software startup.
          The available solutions were tedious and inefficient.
          We decided to stop for a moment and build a better tool.
          It worked.
          The result helped us find our flow again.
          We made it available to the community as an open-source project.
          That <Link href={GITHUB_CLI_REPO_URL} underlined data-track='external:see-humble-tool'>humble tool</Link> quickly captured developers’ hearts
          and gradually became one of the top projects on GitHub.
        </Text>
        */}
        <Text fontSize={[18, 14, 18]} className={styles.description}>
          It all started with a problem: API testing was slowing us down, and the available solutions were tediously
          inefficient.
        </Text>

        <Text fontSize={[18, 14, 18]} className={styles.description}>
          We decided to scratch our own itch and build a better solution—one that helped us keep our flow.
          That{' '}
          <Link href={GITHUB_CLI_REPO_URL} underlined data-track='external:see-humble-tool'>
            humble tool
          </Link> quickly captured developers’ hearts and rapidly became one of the top projects on
          GitHub.
        </Text>
        <Text fontSize={[18, 14, 18]} className={styles.description}>
          We’re now building on top of that success.
          The power and virtually limitless potential of APIs captivate us.
          There’s still a lot of work to be done to unleash them fully.
        </Text>
        <Text fontSize={[18, 14, 18]} className={styles.description}>
          We’re on a mission to make APIs simple and intuitive for all those building the tools, apps, and technologies of our time.
          We truly believe that APIs have the capacity to make our world a better place.
        </Text>
        <Text fontSize={[18, 14, 18]} className={styles.description}>
          Applying the same principles that made our original tool so beloved,
          and utilizing state-of-the-art artificial intelligence,
          we're building a collaborative platform for API development.
        </Text>
        <Text fontSize={[18, 14, 18]} className={styles.description}>
          Our vision is an uncompromisingly human-centric yet powerful product
          helping developers and teams throughout the API lifecycle, especially in places where humans and
          APIs intersect.
        </Text>
      </div>
    </div>
  )
}

export default AboutHero
